import { DashboardEligibleOffer } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<DashboardEligibleOffer>[] = [{
  type: TColumn.type.Ellipsis,
  width: 250,
  title: 'Offer Name',
  dataIndex: 'offerName',
}, {
  type: TColumn.type.Tags,
  width: 150,
  title: 'SKUs',
  dataIndex: 'supportedSkus',
}, {
  type: TColumn.type.Tags,
  title: 'Names',
  dataIndex: 'supportedLineItemNames',
}, {
  width: 80,
  title: 'Miles Value',
  dataIndex: 'rewardMiles',
}];
